import React, { useEffect, useState } from "react";
import Index from "../../../../Index";
import PagesIndex from "../../../../PagesIndex";
import DataService, { imagePath } from "../../../../../config/DataService";
import {
  currentAndPreviousYearProgramBillOfFaimly,
  getAllFamilyWithMohollaNameAndAreaList,
  getCheckAuthenticationDocument,
  getCurrentYearSahayApplicationForView,
  getFamilyAddress,
  getFamilyMemberById,
  getPreviousSahayApplicationListViewSahay,
  getSingleSahayApplication,
} from "../../../../../redux/features/AddService";
import { Api } from "../../../../../config/Api";
import { toast } from "react-toastify";
import PageLoading from "../../../../../components/common/pageLoading/PageLoading";

import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import moment from "moment";
import dayjs from "dayjs";
import axios from "axios";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#eaac35",
    color: "#ffffff",
    fontSize: "11px",
    fontFamily: "Poppins-Regular",
    padding: "5px 9px",
    lineHeight: "19px",
    borderRadius: "10px",
  },
}));

const ariaLabel = { "aria-label": "description" };
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const SahayApplicationView = () => {
  const [previousListData, setPreviousListData] = useState([]);

  const [singlaFamilyId, setSingleFamilyId] = useState();
  const [familyMembers, setFamilyMembers] = useState();
  const [editSingleApplicantData, setEditSingleApplicantData] = useState();
  const [uploadOpen, setUploadOpen] = React.useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [uploadSahayId, setUploadSahayId] = useState("");
  const [familyListWithArea, setFamilyListWithArea] = useState([]);
  const [currentAndPreviousProgramData, setCurrentAndPreviousProgramData] =
    useState([]);
  const [showCurrentYearSahayApplication, setShowCurrentYearSahayApplication] =
    useState([]);

  const { state } = PagesIndex.useLocation();
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const [getViewData, setGetViewData] = useState(null);
  const [blobImageUrl, setBlobImgUrl] = useState(null);
  const [familyAddress, setFamilyAddress] = useState({});

  const [loader, setLoader] = useState(true);
  const initialValues = {};
  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();
  const editPreviousData = state;

  const handleBack = () => {
    navigate(`/${rollData}/sahay-application`, {
      state: {
        rowId: state?.applicationId,
        tabType: "current",
        prevState: state?.lastStatus,
        prevSahayFilter: state?.SahayTypeFilter,
        prevSubSahayFilter: state?.subSahayTypeFilter,
      },
    });
  };

  const handleOpenUpload = (id) => {
    setUploadSahayId(id);
    setUploadOpen(true);
  };

  const handleCloseUploadModal = () => setUploadOpen(false);

  const getSingleSahayApplication = async () => {
    try {
      await DataService.get(
        `${Api.GET_SINGLE_SAHAY_APPLICATION}/${state.applicationId}`,
      ).then((res) => {
        if (res.data.status === 200) {
          setLoader(false);
          setGetViewData(res?.data?.data);
          fetchSingleApplicant(res.data.data.application[0]);
        }
      });
    } catch (error) {
      // toast.error(error.response.data.message || error.message);
    }
  };

  const previousYearSahayList = () => {
    const data = {
      applicantId: state?.applicantId,
    };
    dispatch(getPreviousSahayApplicationListViewSahay(data)).then((res) => {
      if (res) {
        setLoader(false);
        setPreviousListData(res?.payload);
      }
      setLoader(false);
    });
  };

  //Single applicant
  const fetchSingleSelectedApplicant = (memberData) => {
    const member =
      memberData &&
      memberData?.filter(
        (member) => member?.id == editPreviousData?.applicantId,
      );

    if (member?.[0]) {
      setEditSingleApplicantData({
        name:
          member?.[0]?.firstName +
          " " +
          member?.[0]?.middleName +
          " " +
          member?.[0]?.lastName,

        age: member?.[0]?.age ? member?.[0]?.age : 0,
        workingType: member?.[0]?.workingType,
        relation: member?.[0]?.relation,
        relation_id: member?.[0]?.relation_id,
      });
    }
  };

  //fetch single applicant
  const fetchSingleApplicant = (familydata) => {
    let familyId;
    if (editPreviousData?.editSahay) {
      familyId = editPreviousData?.editSahay?.familyId;
    } else {
      familyId = editPreviousData?.familyId;
    }

    let data;
    if (familydata?.vastipatrak == "0") {
      data = {
        familyId: familyId,
        VastiPatra: false,
      };
    } else {
      data = {
        familyId: familyId,
        VastiPatra: true,
      };
    }
    setSingleFamilyId(familyId);

    dispatch(getFamilyMemberById(data)).then((res) => {
      if (res?.payload) {
        setFamilyMembers(res?.payload);
        fetchSingleSelectedApplicant(res?.payload);
      }
    });
  };
  const fetchCurrentYearSahayApplications = (familydata) => {
    let familyId;
    if (editPreviousData?.editSahay) {
      familyId = editPreviousData?.editSahay?.familyId;
    } else {
      familyId = editPreviousData?.familyId;
    }
    const data = {
      familyId: familyId,
    };

    // setSingleFamilyId(familyId);

    dispatch(getCurrentYearSahayApplicationForView(data)).then((res) => {
      if (res?.payload) {
        setShowCurrentYearSahayApplication(res?.payload); //setShowCurrentYearSahayApplication
      }
    });
  };

  const handleUploadSubmit = async (values) => {
    // handleSahayApplicationStatus(approvedAmountIdData, "Approved");
    handleCloseUploadModal();
    const data = new FormData();

    values?.loanDoc?.forEach((row, index) =>
      data?.append(`loanDoc[${index}]`, row),
    );

    data?.append("id", uploadSahayId);

    try {
      const response = await DataService.post(
        `${Api.UPDATE_UPLOAD_LOAN_DOCUMENT}`,
        data,
      );

      if (response?.data?.status === 200) {
        getSingleSahayApplication();
      }
    } catch (error) {}
  };

  const getCurrentAndPreviousProgramData = async () => {
    try {
      let familyId;
      if (editPreviousData?.editSahay) {
        familyId = editPreviousData?.editSahay?.familyId;
      } else {
        familyId = editPreviousData?.familyId;
      }
      const response = await currentAndPreviousYearProgramBillOfFaimly({
        familyId,
      });
      // console.log("response", response);
      setCurrentAndPreviousProgramData(response?.data || []);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    getSingleSahayApplication();
    previousYearSahayList();
    fetchCurrentYearSahayApplications();
    getCurrentAndPreviousProgramData();
  }, []);

  const getFamilyListWithArea = () => {
    const data = {
      mobile: getViewData?.application[0]?.patanMemberMobile,
    };
    dispatch(getAllFamilyWithMohollaNameAndAreaList(data)).then((res) => {
      if (res?.payload) {
        setFamilyListWithArea(res?.payload?.data);
      } else {
        setFamilyListWithArea([]);
      }
    });
  };

  useEffect(() => {
    if (getViewData?.application[0]?.patanMemberMobile?.length >= 10) {
      getFamilyListWithArea();
    }
  }, [getViewData?.application[0]?.patanMemberMobile]);

  const renderDocument = (url, filename) => {
    let extension = "";

    if (filename) {
      extension = filename.split(".").pop().toLowerCase();
    } else if (url && url.startsWith("blob:")) {
      extension = ""; // Blob URL cannot detect type without filename
    } else if (url) {
      extension = url.split(".").pop().toLowerCase();
    }
    if (["png", "jpg", "jpeg", "gif", "webp"].includes(extension)) {
      return <img src={url} alt="Document" className="fullscreen-image" />;
    } else if (extension === "pdf") {
      return (
        <iframe
          src={url}
          title="PDF Document"
          className="fullscreen-pdf"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else if (["doc", "docx"].includes(extension)) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            url,
          )}`}
          title="Word Document"
          className="fullscreen-doc"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else {
      return <p style={{ color: "#fff" }}>Unsupported or Unknown file type</p>;
    }
  };

  const openSecureImageWithAuth = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
      }

      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
        const ComponentData = "adminviewsahay";
        navigate(`/${rollData}/doc-image-view`, {
          state: {
            blobUrl,
            docImageData,
            state,
            ComponentData,
          },
        });
      } else {
        toast.error("Signed URL not received.");
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };

  const openSecureImageWithAuthWithoutNavigate = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
        setBlobImgUrl(blobUrl);
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };
  // console.log("getViewData==getViewData", getViewData?.application[0]?.image);
  useEffect(() => {
    openSecureImageWithAuthWithoutNavigate(getViewData?.application[0]?.image);
  }, [getViewData?.application[0]?.image]);

  const fetchFamilyAddress = async (familyId) => {
    try {
      const res = await dispatch(getFamilyAddress(familyId));
      setFamilyAddress(res?.payload?.data?.data);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    const familyId = getViewData?.application?.[0]?.mem_family_id;
    if (familyId) fetchFamilyAddress(familyId);
  }, [getViewData]);

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box>
                <Index.Box className="title-header-flex-button">
                  <Index.Box className="common-button blue-button flex-start save-btn res-set-search">
                    <Index.Button
                      variant="contained"
                      onClick={() => handleBack()}
                    >
                      Back
                    </Index.Button>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <PagesIndex.Formik
                initialValues={initialValues}
                enableReinitialize
              >
                {({ values }) => (
                  <form>
                    <Index.Box className="">
                      <Index.Grid container spacing={3}>
                        {getViewData?.application[0]?.image && (
                          <Index.Grid item xs={12} sm={12} md={12}>
                            <Index.Box className="main-card-box">
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      View Sahay Application
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label "
                              >
                                Image (છબી)
                              </Index.Typography>
                              <Index.Box
                                style={{ height: "50px", cursor: "pointer" }}
                                className="mb-5 mt-5"
                                onClick={() =>
                                  openSecureImageWithAuth(
                                    getViewData?.application[0]?.image,
                                  )
                                }
                              >
                                {/* {renderDocument(
                                  state.blobUrl,
                                  state.docImageData
                                )} */}
                                {renderDocument(
                                  blobImageUrl,
                                  getViewData?.application[0]?.image,
                                )}
                                {/* {getViewData?.application[0]?.image && (
                                  <img
                                    style={{ width: "120px", height: "120" }}
                                    src={`${imagePath}${getViewData?.application[0]?.image}`}
                                    className="  mb-5 mt-5"
                                  />
                                )} */}
                              </Index.Box>
                            </Index.Box>
                          </Index.Grid>
                        )}
                        {getViewData?.document
                          ?.map((data) => ({
                            documentType: data.documentType,
                            documents: data.documents?.filter(
                              (doc) => doc.document !== "null",
                            ),
                          }))
                          ?.filter((item) => item.documents?.length > 0)
                          ?.length > 0 ? (
                          <Index.Grid item xs={12} sm={12} md={12}>
                            <Index.Box className="main-card-box">
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Documents (દસ્તાવેજો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Grid item xs={12}>
                                <Index.Box className="select-view-document-name">
                                  <Index.Box className="select-view-document-name mt-select-doc">
                                    {/* <Index.Box className="select-view-document-name mt-select-doc">
                                  {getViewData?.document
                                    ?.map((data) =>
                                      data?.documents?.filter(
                                        (ele) => ele?.document !== "null"
                                      )
                                    )
                                    .map((item, fileIndex) => {
                                      return (
                                        <>
                                
                                          {item?.documentType  &&
                                            item?.documents?.length > 0 && (
                                              <Index.Box className="roles-data-box add-check-flex-doc">
                                                <Index.Box className="add-role-flex">
                                                  <Index.Box className="role-data-title">
                                                    {item.documentType}
                                                  </Index.Box>
                                                </Index.Box>
                                              </Index.Box>
                                            )}
                                          {item?.documents
                                            ?.filter(
                                              (ele) => ele?.document !== "null"
                                            )
                                            .map((document, documentIndex) => (
                                              <Index.Box
                                              className="select-view-document-name mt-select-doc"
                                              key={documentIndex}
                                              >
                                           
                                                <Index.Box className="document-name">
                                                  <Index.Typography
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                      window.open(
                                                        document instanceof Blob
                                                          ? URL.createObjectURL(
                                                              document
                                                            )
                                                          : `${imagePath}${document?.filename}`
                                                      );
                                                    }}
                                                  >
                                                    {document instanceof Blob
                                                      ? document.name
                                                      : document?.document}
                                                  </Index.Typography>
                                                  <Index.IconButton
                                                    onClick={() => {
                                               
                                                      // Implement your logic to remove the document
                                                    }}
                                                  >
                                                    <Index.ClearIcon className="muiico-cancel" />
                                                  </Index.IconButton>
                                                </Index.Box>
                                              </Index.Box>
                                            ))}
                                        </>
                                      );
                                    })}
                                </Index.Box> */}

                                    {getViewData?.document
                                      ?.map((data) => ({
                                        documentType: data.documentType,
                                        documents: data.documents?.filter(
                                          (doc) =>
                                            doc.document !== "null" &&
                                            doc.document !== "demo.png",
                                        ),
                                      }))
                                      ?.filter(
                                        (item) => item.documents?.length > 0,
                                      )
                                      ?.map((item, fileIndex) => (
                                        <>
                                          <div key={fileIndex}>
                                            <Index.Box className="roles-data-box add-check-flex-doc">
                                              <Index.Box className="add-role-flex">
                                                <Index.Box className="role-data-title">
                                                  {item.documentType}
                                                </Index.Box>
                                              </Index.Box>
                                            </Index.Box>

                                            {/* Iterate over filtered documents and display them */}
                                            <div>
                                              {item.documents.map(
                                                (document, documentIndex) => (
                                                  <Index.Box
                                                    className="select-view-document-name mt-select-doc"
                                                    key={documentIndex}
                                                  >
                                                    <Index.Box className="document-name">
                                                      <Index.Typography
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          openSecureImageWithAuth(
                                                            document?.filename,
                                                          )
                                                        }
                                                      >
                                                        {document instanceof
                                                        Blob
                                                          ? document.name
                                                          : document?.document}
                                                      </Index.Typography>
                                                    </Index.Box>
                                                  </Index.Box>
                                                ),
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ))}
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                            </Index.Box>
                          </Index.Grid>
                        ) : (
                          ""
                        )}
                        {/* Loan Document Start  */}
                        {getViewData?.application?.[0]?.loanAgreementDoc &&
                          getViewData?.application?.[0]?.loanAgreementDoc
                            ?.length > 0 && (
                            <Index.Grid item xs={12} sm={12} md={12}>
                              {/* <Index.Box className="title-header"> */}
                              <Index.Box className="title-main ">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Loan Documents (લોન દસ્તાવેજો)
                                </Index.Typography>
                              </Index.Box>
                              {/* </Index.Box> */}

                              <Index.Grid item xs={8}>
                                <Index.Box className="select-view-document-name">
                                  <Index.Box className="select-view-document-name mt-select-doc">
                                    {getViewData?.application?.[0]
                                      ?.loanAgreementDoc &&
                                      // JSON.parse(
                                      getViewData?.application?.[0]?.loanAgreementDoc
                                        // )
                                        ?.map((item, fileIndex) => (
                                          <>
                                            {/* Iterate over filtered documents and display them */}

                                            <Index.Box className="select-view-document-name mt-select-doc">
                                              <Index.Box className="document-name">
                                                <Index.Typography
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    window.open(
                                                      item instanceof Blob
                                                        ? URL.createObjectURL(
                                                            item,
                                                          )
                                                        : `${imagePath}${item?.Documents}`,
                                                    );
                                                  }}
                                                >
                                                  {item instanceof Blob
                                                    ? item.Filename
                                                    : item?.Documents}
                                                </Index.Typography>
                                              </Index.Box>
                                            </Index.Box>
                                          </>
                                        ))}
                                    <Index.IconButton
                                      onClick={() => {
                                        handleOpenUpload(
                                          getViewData?.application?.[0]
                                            ?.sahayId,
                                        );
                                      }}
                                    >
                                      <Index.Typography>Edit</Index.Typography>
                                      <Index.EditIcon className="muiico-edit" />
                                    </Index.IconButton>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          )}
                        {/* Loan document End */}
                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Basic Details (મૂળભૂત વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={2} lg={2}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Family ID (કુટુંબ ID)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="familyId"
                                    disabled
                                    value={state?.familyId}
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Aadhar Card No. (આધાર કાર્ડ નં.)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.AadharNo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Sahay Category (સહાય કેટેગરી)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Sahay Category"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.SahayName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Sub Sahay Category (સબ સહાય શ્રેણી)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Sahay Category"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.subSahayName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Year Of Sahay (સહાયનું વર્ષ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.Year
                                        ? getViewData?.application[0]?.Year
                                        : getViewData?.application[0]
                                              ?.fromYear === null
                                          ? "---"
                                          : ` ${getViewData?.application[0]?.fromYear}-${getViewData?.application[0]?.toYear}`
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={5} lg={5}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Application Received Date (અરજી મળ્યાની તારીખ)
                                </Index.Typography>

                                <Index.Box className="input-design-div with-border date-input-box">
                                  <Index.LocalizationProvider
                                    dateAdapter={Index.AdapterDayjs}
                                    sx={{ position: "absolute" }}
                                  >
                                    <Index.DemoContainer
                                      components={["DatePicker"]}
                                    >
                                      <Index.DatePicker
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        name="applicationReceiveDate"
                                        // onChange={(value) => {
                                        //   setFieldValue(
                                        //     "applicationReceiveDate",
                                        //     moment(value.$d).format(
                                        //       "YYYY-MM-DD"
                                        //     )
                                        //   );
                                        // }}
                                        value={dayjs(
                                          getViewData?.application[0]
                                            ?.applicationReceiveDate,
                                        )}
                                        format="YYYY-MM-DD"
                                        sx={{
                                          overflowY: "hidden",
                                          position: "relative",
                                          bottom: "8px",
                                          width: "100%",
                                        }}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: false,
                                          },
                                        }}
                                      />
                                    </Index.DemoContainer>
                                  </Index.LocalizationProvider>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Filing Date (ફાઇલિંગ તારીખ)
                                </Index.Typography>

                                <Index.Box className="input-design-div with-border date-input-box">
                                  <Index.LocalizationProvider
                                    dateAdapter={Index.AdapterDayjs}
                                    sx={{ position: "absolute" }}
                                  >
                                    <Index.DemoContainer
                                      components={["DatePicker"]}
                                    >
                                      <Index.DatePicker
                                        disabled
                                        className="admin-input-design input-placeholder"
                                        name="formFillingDate"
                                        // onChange={(value) => {
                                        //   setFieldValue(
                                        //     "formFillingDate",
                                        //     moment(value.$d).format(
                                        //       "YYYY-MM-DD"
                                        //     )
                                        //   );
                                        // }}
                                        value={dayjs(
                                          getViewData?.application[0]
                                            ?.formFillingDate,
                                        )}
                                        format="YYYY-MM-DD"
                                        sx={{
                                          overflowY: "hidden",
                                          position: "relative",
                                          bottom: "8px",
                                          width: "100%",
                                        }}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: false,
                                          },
                                        }}
                                      />
                                    </Index.DemoContainer>
                                  </Index.LocalizationProvider>
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>
                        {getViewData?.application[0]?.disease !== "NULL" ||
                          (null && (
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Type Of Disease (રોગનો પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.disease
                                      ? getViewData?.application[0]?.disease
                                      : "---"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                          ))}
                        {getViewData?.application[0]?.isLoan == true ? (
                          <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                            <Index.Typography
                              variant="label"
                              component="label"
                              className="input-label"
                            >
                              PAN CARD No. (વિસ્તાર)
                            </Index.Typography>
                            <Index.Box className="input-design-div with-border">
                              <Index.TextField
                                hiddenLabel
                                id="filled-hidden-label-normal"
                                variant="filled"
                                className="admin-input-design input-placeholder"
                                autoComplete="off"
                                name="Addharcard No."
                                disabled
                                // value={getViewData?.application[0]?.workingType}
                                value={
                                  getViewData
                                    ? getViewData?.application?.[0]?.PANCardNo
                                    : editSingleApplicantData?.PANCardNo
                                }
                              />
                            </Index.Box>
                          </Index.Grid>
                        ) : (
                          <></>
                        )}
                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Family Members Details (કુટુંબના સભ્યોની
                                        વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  First Name (પ્રથમ નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="User Name"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.firstName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Middle Name (મધ્ય નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="User Name"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.middleName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Last Name (છેલ્લું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="User Name"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.lastName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Relation (સંબંધ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      editSingleApplicantData
                                        ? editSingleApplicantData?.relation
                                        : getViewData?.application[0]?.relation
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Age (ઉંમર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData
                                        ? getViewData?.application[0]?.age
                                        : editSingleApplicantData?.age
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Working Type (કામનો પ્રકાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.workingType
                                        : editSingleApplicantData?.workingType
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  {/* Beneficiary Name (લાભાર્થીનું નામ) */}
                                  Patient Name ( દર્દીનું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.beneficiaryMemName
                                        : getViewData?.application?.[0]
                                            ?.beneficiaryMemName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Family Income (કૌટુંબિક આવક){" "}
                                  <span className="required">*</span>
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.monthlyIncome
                                        : getViewData?.application?.[0]
                                            ?.monthlyIncome
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Electric Bill amount (ઇલેક્ટ્રિક બિલની રકમ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.threeMonthBillAmount
                                        : getViewData?.application?.[0]
                                            ?.threeMonthBillAmount
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>
                        {/* <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                          <Index.Typography
                            variant="label"
                            component="label"
                            className="input-label"
                          >
                            Monthly Income
                          </Index.Typography>
                          <Index.Box className="input-design-div with-border">
                            <Index.TextField
                              hiddenLabel
                              id="filled-hidden-label-normal"
                              variant="filled"
                              className="admin-input-design input-placeholder"
                              autoComplete="off"
                              name="Addharcard No."
                              disabled
                              value={
                                getViewData?.application[0]?.monthlyIncome
                                  ? getViewData?.application[0]?.monthlyIncome
                                  : "---"
                              }
                            />
                          </Index.Box>
                        </Index.Grid> */}
                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Bank Details (બેંક વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Bank Name (બેંકનું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.bankName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Branch (શાખા)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={getViewData?.application[0]?.branch}
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Account Holder Name (એકાઉન્ટ ધારકનું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.HolderName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Account Number (એકાઉન્ટ નંબર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.AccountNo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  IFSC code (IFSC કોડ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.IFSCCode
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>
                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Sahay Details (સહાય વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              {getViewData?.application[0]?.claimedAmmount !==
                                0 && (
                                <>
                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      {/* Claimed Sahay Amount */}
                                      Total Requested Sahay Amount (કુલ વિનંતી
                                      કરેલ સહાય રકમ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        id="filled-hidden-label-normal"
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        autoComplete="off"
                                        name="Addharcard No."
                                        disabled
                                        value={
                                          getViewData?.application[0]
                                            ?.claimedAmmount
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>{" "}
                                </>
                              )}
                              {getViewData?.application[0]?.approveAmount &&
                              getViewData?.application[0]?.approveAmount !==
                                0 ? (
                                <>
                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      {/* Claimed Sahay Amount */}
                                      Approve Amount* (રકમ મંજૂર)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        id="filled-hidden-label-normal"
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        autoComplete="off"
                                        name="Addharcard No."
                                        disabled
                                        value={
                                          getViewData?.application[0]
                                            ?.approveAmount
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>{" "}
                                </>
                              ) : (
                                ""
                              )}
                              <Index.Grid item xs={12} sm={6} md={6}>
                                <Index.Box className="lable-input-grp">
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Remark (ટિપ્પણી)
                                  </Index.Typography>
                                  {/* <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="remark"
                                        value={values?.remark}
                                        onChange={handleChange}
                                        // onBlur={handleBlur}
                                      /> */}
                                  <Index.TextareaAutosize
                                    style={{
                                      fontSize: "15px",
                                      color: "black",
                                      padding: "4px",
                                      minHeight: "50px",
                                      width: "100%",
                                    }}
                                    minRows={1}
                                    inputProps={ariaLabel}
                                    className="basic-input input-width"
                                    name="remark"
                                    value={getViewData?.application[0]?.remark}

                                    // onBlur={handleBlur}
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>
                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Reference / Guarantor (સંદર્ભ / બાંયધરી
                                        આપનાર)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>

                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Mobile Number (મોબાઈલ નંબર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]
                                        ?.patanMemberMobile
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  FID (કૌટુંબિક આઈડી)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile,
                                      )
                                        ? familyListWithArea?.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile,
                                          )?.mem_family_id
                                        : ""
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Reference / Guarantor (સંદર્ભ / બાંયધરી આપનાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile,
                                      )
                                        ? `${
                                            familyListWithArea.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                getViewData?.application[0]
                                                  ?.patanMemberMobile,
                                            )?.mem_fname
                                          } ${
                                            familyListWithArea.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                getViewData?.application[0]
                                                  ?.patanMemberMobile,
                                            )?.mem_mname
                                          } ${
                                            familyListWithArea.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                getViewData?.application[0]
                                                  ?.patanMemberMobile,
                                            )?.mem_lname
                                          }`
                                        : values?.patanReferenceName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Mohalla Name (મહોલ્લો નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile,
                                      )
                                        ? familyListWithArea?.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile,
                                          )?.mohollo_name
                                        : values?.patanReferenceMohollo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Area (વિસ્તાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile,
                                      )
                                        ? familyListWithArea?.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile,
                                          )?.family_area
                                        : values?.patanReferenceArea
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>
                        {/* addresssssss */}
                        {(rollData.toLowerCase() === "committee" ||
                          rollData.toLowerCase() === "staff") && (
                          <Index.Grid item xs={12} sm={12} md={12}>
                            <Index.Box className="main-card-box">
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="title-header">
                                    <Index.Box className="title-header-flex">
                                      <Index.Box className="title-main ">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Family Address (કુટુંબનું સરનામું)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Residential Address 1 (રહેણાંક સરનામું 1)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_res_address1}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Residential Address 2 (રહેણાંક સરનામું 2)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_res_address2}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Mohalla Name (મોહલ્લાનું નામ)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_mohollo}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Area (વિસ્તાર)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_area}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    City (શહેર)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_city}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    State (રાજ્ય)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_state}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Country (દેશ)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_country}
                                    />
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Pincode (પિનકોડ)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      disabled
                                      value={familyAddress?.family_pincode}
                                    />
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>
                          </Index.Grid>
                        )}
                        <Index.Grid item xs={12} md={12}>
                          <Index.Box className="title-header" mt={5}>
                            <Index.Box className="title-header-flex res-title-header-flex">
                              <Index.Box className="title-main">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Family Members Details (કુટુંબના સભ્યોની
                                  વિગતો)
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="">
                            <Index.TableContainer
                              component={Index.Paper}
                              className="table-container"
                            >
                              <Index.Table
                                aria-label="simple table"
                                className="table-design-main barge-table "
                              >
                                <Index.TableHead>
                                  <Index.TableRow>
                                    <Index.TableCell>
                                      Name (નામ)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Age (ઉંમર)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Relation (સંબંધ)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Working Type (કામનો પ્રકાર)
                                    </Index.TableCell>
                                    {/* <Index.TableCell align="left">
                                      {" "}
                                      Monthly Income
                                    </Index.TableCell> */}
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody>
                                  {/* {getViewData?.relationRecords?.length ? (
                                    getViewData?.relationRecords */}
                                  {familyMembers?.length ? (
                                    familyMembers
                                      ?.filter((ele) => {
                                        return (
                                          ele?.id !=
                                          getViewData?.application?.[0]
                                            ?.applicantId
                                        );
                                      })
                                      ?.map((data, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell>
                                              {/* {data?.name} */}
                                              {`${data?.firstName} ${data?.middleName} ${data?.lastName}` ||
                                                "-"}
                                            </Index.TableCell>

                                            <Index.TableCell align="left">
                                              {data?.age || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.relation || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.workingType || "-"}
                                              {/* {data?.WorkingType} */}
                                            </Index.TableCell>
                                            {/* <Index.TableCell align="left">
                                              {data?.monthlyIncome}
                                            </Index.TableCell> */}
                                          </Index.TableRow>
                                        );
                                      })
                                  ) : (
                                    <Index.TableRow>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="no-data-in-list"
                                        colSpan={6}
                                        align="center"
                                      >
                                        No data available
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )}
                                </Index.TableBody>
                              </Index.Table>
                            </Index.TableContainer>
                          </Index.Box>
                        </Index.Grid>

                        {/* Policy Holders' Details (પોલીસી ધારકોની વિગતઃ) */}
                        {getViewData?.application[0]?.subSahayName?.toLowerCase() ==
                          "mediclaim premium sahay" && (
                          <>
                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header" mt={5}>
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Policy Holders' Details (પોલીસી ધારકોની
                                      વિગતઃ)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table "
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>
                                          Full Name (પુરું નામ)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Relationship (સંબંધ)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Age (ઉંમર)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Sum Insured (વીમાની રકમ)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Total Premium (કુલ પ્રીમિયમ)
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.policyHolders?.length >
                                      0 ? (
                                        getViewData?.policyHolders?.map(
                                          (data, index) => {
                                            return (
                                              <Index.TableRow key={index}>
                                                <Index.TableCell>
                                                  {data?.fullName || "-"}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.relationship || "-"}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.age || "-"}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.sumInsured || "-"}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.totalPremium || "-"}
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            );
                                          },
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            scope="row"
                                            className="no-data-in-list"
                                            colSpan={6}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>

                            {/* Insurance Information Section */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Box className="main-in-row">
                                  <Index.Box className="user-basic"></Index.Box>
                                  <Index.Box
                                    sx={{ flexGrow: 1 }}
                                    className="al-form-groups family-detail"
                                  >
                                    <Index.Grid container spacing={2}>
                                      <Index.Grid item xs={12} sm={12} md={12}>
                                        <Index.Box className="title-header">
                                          <Index.Box className="title-header-flex">
                                            <Index.Box className="title-main ">
                                              <Index.Typography
                                                variant="p"
                                                component="p"
                                                className="page-title"
                                              >
                                                Insurance Information (વીમા
                                                માહિતી)
                                              </Index.Typography>
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>
                                      {/* Insurance Co. Name */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Insurance Co. Name (ઈન્સ્યુરન્સ કું.
                                            નું નામ)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="insuranceCompanyName"
                                              value={
                                                getViewData?.application[0]
                                                  ?.insuranceCompanyName || ""
                                              }
                                              disabled
                                              fullWidth
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Branch No. */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Branch No. (બ્રાન્ચ નં.)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="branchNumber"
                                              value={
                                                getViewData?.application[0]
                                                  ?.branchNumber || ""
                                              }
                                              disabled
                                              fullWidth
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy No. */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy No. (પોલીસી નં.)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              className="basic-input input-width"
                                              value={
                                                getViewData?.application[0]
                                                  ?.policyNumber || ""
                                              }
                                              name="policyNumber"
                                              inputProps={ariaLabel}
                                              fullWidth
                                              disabled
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Place */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Place (સ્થળ)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="place"
                                              value={
                                                getViewData?.application[0]
                                                  ?.place || ""
                                              }
                                              fullWidth
                                              disabled
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Total Premium Paid */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Total Premium Paid (Rs.) (ભરેલ કુલ
                                            પ્રીમિયમ રૂ.)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="totalPremiumPaid"
                                              type="number"
                                              value={
                                                getViewData?.application[0]
                                                  ?.totalPremiumPaid || ""
                                              }
                                              fullWidth
                                              disabled
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy Term: From */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy Term: From (પોલીસીની મુદત તા)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border date-input-box">
                                            <Index.LocalizationProvider
                                              dateAdapter={Index.AdapterDayjs}
                                            >
                                              <Index.DemoContainer
                                                components={["DatePicker"]}
                                              >
                                                <Index.DatePicker
                                                  name="policyTermFrom"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.policyTermFrom
                                                      ? dayjs(
                                                          getViewData
                                                            ?.application[0]
                                                            .policyTermFrom,
                                                        )
                                                      : null
                                                  }
                                                  format="YYYY-MM-DD"
                                                  sx={{
                                                    width: "100%",
                                                  }}
                                                  slotProps={{
                                                    textField: {
                                                      size: "small",
                                                      error: false,
                                                    },
                                                  }}
                                                  disabled
                                                />
                                              </Index.DemoContainer>
                                            </Index.LocalizationProvider>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy Term: To */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy Term: To (પોલીસીની મુદત સુધી)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border date-input-box">
                                            <Index.LocalizationProvider
                                              dateAdapter={Index.AdapterDayjs}
                                            >
                                              <Index.DemoContainer
                                                components={["DatePicker"]}
                                              >
                                                <Index.DatePicker
                                                  name="policyTermTo"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.policyTermTo
                                                      ? dayjs(
                                                          getViewData
                                                            ?.application[0]
                                                            ?.policyTermTo,
                                                        )
                                                      : null
                                                  }
                                                  format="YYYY-MM-DD"
                                                  sx={{
                                                    width: "100%",
                                                  }}
                                                  slotProps={{
                                                    textField: {
                                                      size: "small",
                                                      error: false,
                                                    },
                                                  }}
                                                  disabled
                                                />
                                              </Index.DemoContainer>
                                            </Index.LocalizationProvider>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Last Year Details: During the last year up to Rs. */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Last Year Details: During the last
                                            year up to Rs. (ગત વર્ષ દરમિયાન રૂ.
                                            સુધી)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="lastYearAmount"
                                              type="number"
                                              value={
                                                getViewData?.application[0]
                                                  ?.lastYearAmount || ""
                                              }
                                              fullWidth
                                              disabled
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Last Year Details: until Date */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            until Date (તારીખ સુધી)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border date-input-box">
                                            <Index.LocalizationProvider
                                              dateAdapter={Index.AdapterDayjs}
                                            >
                                              <Index.DemoContainer
                                                components={["DatePicker"]}
                                              >
                                                <Index.DatePicker
                                                  name="lastYearUntilDate"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.lastYearUntilDate
                                                      ? dayjs(
                                                          getViewData
                                                            ?.application[0]
                                                            .lastYearUntilDate,
                                                        )
                                                      : null
                                                  }
                                                  format="YYYY-MM-DD"
                                                  sx={{
                                                    width: "100%",
                                                  }}
                                                  slotProps={{
                                                    textField: {
                                                      size: "small",
                                                      error: false,
                                                    },
                                                  }}
                                                  disabled
                                                />
                                              </Index.DemoContainer>
                                            </Index.LocalizationProvider>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy Type */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy Type (પોલિસીનો પ્રકાર)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.FormControl
                                              sx={{ width: "100%" }}
                                              className="main-select"
                                            >
                                              <Index.Select
                                                className="select-drop"
                                                displayEmpty
                                                name="policyTypeSelect"
                                                value={
                                                  getViewData?.application[0]
                                                    ?.policyTypeSelect || ""
                                                }
                                                input={<Index.OutlinedInput />}
                                                // MenuProps={MenuProps}
                                                disabled
                                              >
                                                <Index.MenuItem value="">
                                                  <em>Select Type</em>
                                                </Index.MenuItem>
                                                <Index.MenuItem value="new">
                                                  New
                                                </Index.MenuItem>
                                                <Index.MenuItem value="renewal">
                                                  Renewal
                                                </Index.MenuItem>
                                              </Index.Select>
                                            </Index.FormControl>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Claim History */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Claim History: Claim has been
                                            received (ક્લેઇમ મેળવેલ છે)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.RadioGroup
                                              row
                                              name="claimReceived"
                                              value={
                                                getViewData?.application[0]
                                                  ?.claimReceived || ""
                                              }
                                              disabled
                                            >
                                              <Index.FormControlLabel
                                                value="yes"
                                                control={<Index.Radio />}
                                                label="Yes"
                                              />
                                              <Index.FormControlLabel
                                                value="no"
                                                control={<Index.Radio />}
                                                label="No"
                                              />
                                            </Index.RadioGroup>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Box>

                                {/* Important Notes Section */}
                                <Index.Box
                                  className="notes-section"
                                  sx={{
                                    mt: 4,
                                    p: 2,
                                    border: "1px solid #ddd",
                                    borderRadius: 1,
                                  }}
                                >
                                  <Index.Typography
                                    className="note-title"
                                    sx={{ fontWeight: "bold", mb: 2 }}
                                  >
                                    Important Notes (મહત્વની નોંધ)
                                  </Index.Typography>

                                  <Index.Box className="note-points">
                                    {/* Point 1 */}
                                    <Index.Typography
                                      className="note-point"
                                      sx={{ mb: 1.5 }}
                                    >
                                      (1) It is mandatory to send the receipt of
                                      the amount paid to the Insurance Co. and a
                                      photocopy of the policy along with the
                                      application form.
                                      <br />
                                      (ઈન્સ્યુરન્સ કું. માં ભરેલ રકમની રસીદ તથા
                                      પોલીસીની ઝેરોક્ષ, અરજી પત્રક સાથે મોકલવી
                                      જરૂરી છે.)
                                    </Index.Typography>

                                    {/* Point 2 */}
                                    <Index.Typography
                                      className="note-point"
                                      sx={{ mb: 1.5 }}
                                    >
                                      (2) This form must be filled and sent to
                                      the association's office within four
                                      months from the date of minimum payment.
                                      <br />
                                      (મિનિમમ લાયકાતની તારીખથી ચાર માસ સુધીમાં આ
                                      ફોર્મ ભરીને મંડળના કાર્યાલયમાં મોકલવા
                                      જરૂરી છે.)
                                    </Index.Typography>

                                    {/* Point 3 */}
                                    <Index.Typography
                                      className="note-point"
                                      sx={{ mb: 1.5 }}
                                    >
                                      (3) Applications received after that
                                      period will not be accepted.
                                      <br />
                                      (ત્યારબાદ મળેલ અરજી સ્વીકાર્ય ગણાશે નહીં.)
                                    </Index.Typography>

                                    {/* Point 4 - Radio buttons */}
                                    {/* <Index.Box
                                      className="note-point-with-input"
                                      sx={{ mb: 1.5 }}
                                    >
                                      <Index.Typography component="p">
                                        (4) Have you taken an SBI General
                                        Mediclaim Policy through the
                                        association?
                                        <br />
                                        (મંડળ દ્વારા SBI જનરલ મેડિકલેઈમ પોલીસી
                                        લીધી છે?)
                                      </Index.Typography>
                                      <Index.RadioGroup
                                        row
                                        name="sbiPolicyTaken"
                                        value={
                                          getViewData?.application[0]
                                            ?.sbiPolicyTaken || ""
                                        }
                                        disabled
                                      >
                                        <Index.FormControlLabel
                                          value="yes"
                                          control={<Index.Radio />}
                                          label="Yes (હા)"
                                        />
                                        <Index.FormControlLabel
                                          value="no"
                                          control={<Index.Radio />}
                                          label="No (ના)"
                                        />
                                      </Index.RadioGroup>
                                    </Index.Box> */}

                                    {/* Point 5 - Text input */}
                                    <Index.Box
                                      className="note-point-with-input"
                                      sx={{ mb: 1.5 }}
                                    >
                                      <Index.Typography
                                        component="p"
                                        sx={{ mb: 0.5 }}
                                      >
                                        (5) Reason for taking the policy (પોલીસી
                                        લેવાનું કારણ):
                                      </Index.Typography>
                                      <Index.TextField
                                        fullWidth
                                        name="policyReason"
                                        value={
                                          getViewData?.application[0]
                                            ?.policyReason || ""
                                        }
                                        disabled
                                        className="basic-input"
                                        placeholder="Enter reason..."
                                        multiline
                                        rows={2}
                                      />
                                    </Index.Box>

                                    {/* Point 6 - Radio buttons */}
                                    <Index.Box
                                      className="note-point-with-input"
                                      sx={{ mb: 1.5 }}
                                    >
                                      <Index.Typography
                                        component="p"
                                        sx={{ mb: 0.5 }}
                                      >
                                        (6) Policy Category (પોલીસીનો પ્રકાર):
                                      </Index.Typography>
                                      <Index.RadioGroup
                                        row
                                        name="policyCategory"
                                        value={
                                          getViewData?.application[0]
                                            ?.policyCategory || ""
                                        }
                                        disabled
                                      >
                                        <Index.FormControlLabel
                                          value="group"
                                          control={<Index.Radio />}
                                          label="Group Policy (ગ્રુપ પોલીસી)"
                                        />
                                        <Index.FormControlLabel
                                          value="individual"
                                          control={<Index.Radio />}
                                          label="Individual Policy (ઈન્ડીવિજ્યુઅલ પોલીસી)"
                                        />
                                      </Index.RadioGroup>
                                    </Index.Box>

                                    {/* Point 7 */}
                                    <Index.Typography
                                      component="p"
                                      className="note-point"
                                      sx={{
                                        fontWeight: "bold",
                                        color: "error.main",
                                      }}
                                    >
                                      (7) All details have been carefully
                                      verified in writing. Forms with incomplete
                                      details will not be considered.
                                      <br />
                                      (કોઈપણ વિગત ખોટી લખી છે તો તે માન્ય રહેશે
                                      નહીં. અધૂરી વિગતોવાળા ફોર્મ પર ધ્યાન
                                      આપવામાં આવશે નહીં.)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                          </>
                        )}

                        {/* Medicine Sahay Guidelines and Instructions  */}
                        {getViewData?.application[0]?.subSahayName?.toLowerCase() ==
                          "medicine sahay" && (
                          <>
                            {/* Insurance Information Section */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Box className="main-in-row">
                                  <Index.Box className="user-basic"></Index.Box>
                                  <Index.Box
                                    sx={{ flexGrow: 1 }}
                                    className="family-detail"
                                  >
                                    {/* Guidelines and Instructions */}
                                    <Index.Box
                                      // className="guidelines-section"
                                      sx={{
                                        mb: 3,
                                        p: 2,
                                        bgcolor: "#f5f5f5",
                                        borderRadius: 1,
                                      }}
                                    >
                                      <Index.Typography
                                        component="h3"
                                        sx={{
                                          fontWeight: "bold",
                                          mb: 1.5,
                                          fontSize: "16px",
                                        }}
                                      >
                                        Guidelines and Instructions
                                        (માર્ગદર્શિકા અને સૂચનાઓ)
                                      </Index.Typography>

                                      <Index.Box
                                        component="ul"
                                        sx={{
                                          pl: 2,
                                          "& li": { mb: 0.5, fontSize: "14px" },
                                        }}
                                      >
                                        <li>
                                          A maximum of four months' worth of
                                          bills may be submitted with the
                                          application.
                                          <br />
                                          (અરજી સાથે મહત્તમ ચાર મહિનાના બિલ્સ
                                          સબમિટ કરી શકાય છે.)
                                        </li>
                                        <li>
                                          Applicant must provide original bills
                                          and a photocopy of the doctor's
                                          prescription.
                                          <br />
                                          (અરજદારે મૂળ બિલ્સ અને ડૉક્ટરના
                                          પ્રિસ્ક્રિપ્શનની ફોટોકોપી આપવી જરૂરી
                                          છે.)
                                        </li>
                                        <li>
                                          Detailed information regarding other
                                          expenses must be recorded on this back
                                          of the form.
                                          <br />
                                          (અન્ય ખર્ચા અંગેની વિગતવાર માહિતી આ
                                          ફોર્મની પાછળની બાજુએ નોંધવી જરૂરી છે.)
                                        </li>
                                        <li>
                                          Multiple claims may be submitted, but
                                          not more than once every six months.
                                          <br />
                                          (બહુવિધ દાવાઓ સબમિટ કરી શકાય છે, પરંતુ
                                          દર છ મહિનામાં એક વાર કરતાં વધુ નહીં.)
                                        </li>
                                        <li>
                                          Applications without a current
                                          prescription will not be considered.
                                          <br />
                                          (વર્તમાન પ્રિસ્ક્રિપ્શન વિનાની અરજીઓ
                                          પર વિચારણા કરવામાં આવશે નહીં.)
                                        </li>
                                        <li>
                                          If monthly expenses are up to Rs.
                                          2000, apply every three months.
                                          <br />
                                          (જો માસિક ખર્ચ રૂ. 2000 સુધી હોય, તો
                                          દર ત્રણ મહિને અરજી કરો.)
                                        </li>
                                        <li>
                                          If monthly expenses are up to Rs.
                                          5000, apply every six months.
                                          <br />
                                          (જો માસિક ખર્ચ રૂ. 5000 સુધી હોય, તો
                                          દર છ મહિને અરજી કરો.)
                                        </li>
                                        <li>
                                          Application must be given to this said
                                          address within one year.
                                          <br />
                                          (અરજી એક વર્ષની અંદર આ સરનામે આપવી
                                          જરૂરી છે.)
                                        </li>
                                      </Index.Box>

                                      {/* Direct Medicine Scheme - Inline in Guidelines */}
                                      <Index.Box
                                        sx={{
                                          mt: 2,
                                          p: 2,
                                          bgcolor: "#fff3cd",
                                          borderRadius: 1,
                                          border: "1px solid #ffc107",
                                        }}
                                      >
                                        <Index.Grid
                                          container
                                          spacing={2}
                                          alignItems="center"
                                        >
                                          <Index.Grid item xs={12} sm={6}>
                                            <Index.Typography
                                              component="p"
                                              sx={{ fontWeight: "bold" }}
                                            >
                                              <strong>
                                                Direct Medicine Scheme:
                                              </strong>{" "}
                                              (ડાયરેક્ટ મેડિસિન યોજના)
                                            </Index.Typography>
                                          </Index.Grid>

                                          <Index.Grid item xs={12} sm={3}>
                                            <Index.Box>
                                              <Index.Typography
                                                component="span"
                                                sx={{ mr: 1 }}
                                              >
                                                Joined? (જોડાયા?)
                                              </Index.Typography>
                                              <Index.RadioGroup
                                                row
                                                name="directMedicineSchemeJoined"
                                                value={
                                                  getViewData?.application[0]
                                                    ?.directMedicineSchemeJoined ||
                                                  ""
                                                }
                                                disabled
                                                // onChange={handleChange}
                                              >
                                                <Index.FormControlLabel
                                                  value="yes"
                                                  control={
                                                    <Index.Radio size="small" />
                                                  }
                                                  label="Yes (હા)"
                                                />
                                                <Index.FormControlLabel
                                                  value="no"
                                                  control={
                                                    <Index.Radio size="small" />
                                                  }
                                                  label="No (ના)"
                                                />
                                              </Index.RadioGroup>
                                            </Index.Box>
                                          </Index.Grid>

                                          <Index.Grid item xs={12} sm={3}>
                                            {getViewData?.application[0]
                                              ?.directMedicineSchemeJoined ===
                                              "no" && (
                                              <Index.Box>
                                                <Index.Typography
                                                  component="span"
                                                  sx={{ mr: 1 }}
                                                >
                                                  Reason (કારણ):
                                                </Index.Typography>
                                                <Index.TextField
                                                  size="small"
                                                  name="directMedicineSchemeReason"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.directMedicineSchemeReason ||
                                                    ""
                                                  }
                                                  disabled
                                                  // onChange={handleChange}
                                                  // placeholder="Enter reason"
                                                  sx={{ width: "100%" }}
                                                />
                                              </Index.Box>
                                            )}
                                          </Index.Grid>
                                        </Index.Grid>
                                      </Index.Box>
                                    </Index.Box>

                                    {/* Summary of Medical Bills Table */}
                                    <Index.Grid item xs={12} md={12}>
                                      <Index.Box
                                        className="title-header"
                                        mt={5}
                                      >
                                        <Index.Box className="title-header-flex res-title-header-flex">
                                          <Index.Box className="title-main">
                                            <Index.Typography
                                              variant="p"
                                              component="p"
                                              className="page-title"
                                            >
                                              Summary of Medical Bills (તબીબી
                                              બિલ્સનો સારાંશ)
                                            </Index.Typography>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Box>
                                      <Index.Box className="">
                                        <Index.TableContainer
                                          component={Index.Paper}
                                          className="table-container"
                                        >
                                          <Index.Table
                                            aria-label="simple table"
                                            className="table-design-main barge-table "
                                          >
                                            <Index.TableHead>
                                              <Index.TableRow>
                                                <Index.TableCell>
                                                  Name of Medical Store (તબીબી
                                                  સ્ટોરનું નામ)
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {" "}
                                                  Date (તારીખ)
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {" "}
                                                  Bill Amount (બિલ રકમ)
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            </Index.TableHead>
                                            <Index.TableBody>
                                              {getViewData?.medicalBills
                                                ?.length > 0 ? (
                                                getViewData?.medicalBills?.map(
                                                  (data, index) => {
                                                    return (
                                                      <Index.TableRow
                                                        key={index}
                                                      >
                                                        <Index.TableCell>
                                                          {data?.storeName ||
                                                            "-"}
                                                        </Index.TableCell>
                                                        <Index.TableCell align="left">
                                                          {data?.date || "-"}
                                                        </Index.TableCell>
                                                        <Index.TableCell align="left">
                                                          {data?.amount || "-"}
                                                        </Index.TableCell>
                                                      </Index.TableRow>
                                                    );
                                                  },
                                                )
                                              ) : (
                                                <Index.TableRow>
                                                  <Index.TableCell
                                                    component="td"
                                                    variant="td"
                                                    scope="row"
                                                    className="no-data-in-list"
                                                    colSpan={6}
                                                    align="center"
                                                  >
                                                    No data available
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              )}
                                            </Index.TableBody>
                                          </Index.Table>
                                        </Index.TableContainer>
                                      </Index.Box>
                                    </Index.Grid>

                                    {/* Assistance from Other Organizations */}
                                    <Index.Box
                                      className="assistance-section"
                                      sx={{
                                        mb: 3,
                                        p: 2,
                                        border: "1px solid #ddd",
                                        borderRadius: 1,
                                      }}
                                    >
                                      <Index.Typography
                                        component="h3"
                                        sx={{
                                          fontWeight: "bold",
                                          mb: 2,
                                          fontSize: "16px",
                                        }}
                                      >
                                        Assistance from Other Organizations
                                        (અન્ય સંસ્થાઓ તરફથી સહાય)
                                      </Index.Typography>

                                      <Index.Box sx={{ mb: 2 }}>
                                        <Index.Typography
                                          component="p"
                                          sx={{ mb: 1 }}
                                        >
                                          Have you received aid from other
                                          unions/organizations? [ ] Yes [ ] No
                                          <br />
                                          (શું તમે અન્ય યુનિયન/સંસ્થાઓ પાસેથી
                                          સહાય મેળવી છે? [ ] હા [ ] ના)
                                        </Index.Typography>

                                        <Index.RadioGroup
                                          row
                                          name="receivedAidFromOthers"
                                          value={
                                            getViewData?.application[0]
                                              ?.receivedAidFromOthers || ""
                                          }
                                          disabled
                                          // onChange={handleChange}
                                        >
                                          <Index.FormControlLabel
                                            value="yes"
                                            control={<Index.Radio />}
                                            label="Yes (હા)"
                                          />
                                          <Index.FormControlLabel
                                            value="no"
                                            control={<Index.Radio />}
                                            label="No (ના)"
                                          />
                                        </Index.RadioGroup>
                                      </Index.Box>

                                      {/* Conditional rendering when Yes is selected */}
                                      {getViewData?.application[0]
                                        ?.receivedAidFromOthers === "yes" && (
                                        <Index.Box className="assistance-details">
                                          <Index.Grid container spacing={2}>
                                            <Index.Grid item xs={12} sm={6}>
                                              <Index.Box>
                                                <Index.Typography
                                                  component="p"
                                                  sx={{ mb: 0.5 }}
                                                >
                                                  1. Name (નામ):
                                                </Index.Typography>
                                                <Index.TextField
                                                  fullWidth
                                                  size="small"
                                                  name="assistanceOrg1Name"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.assistanceOrg1Name || ""
                                                  }
                                                  disabled
                                                  // onChange={handleChange}
                                                  placeholder="Organization Name"
                                                />
                                              </Index.Box>
                                            </Index.Grid>

                                            <Index.Grid item xs={12} sm={6}>
                                              <Index.Box>
                                                <Index.Typography
                                                  component="p"
                                                  sx={{ mb: 0.5 }}
                                                >
                                                  Amount (રકમ):
                                                </Index.Typography>
                                                <Index.TextField
                                                  fullWidth
                                                  size="small"
                                                  type="number"
                                                  name="assistanceOrg1Amount"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.assistanceOrg1Amount ||
                                                    ""
                                                  }
                                                  disabled
                                                  // onChange={handleChange}
                                                  placeholder="Amount"
                                                  inputProps={{
                                                    min: 0,
                                                    step: 0.01,
                                                  }}
                                                />
                                              </Index.Box>
                                            </Index.Grid>

                                            <Index.Grid item xs={12} sm={6}>
                                              <Index.Box>
                                                <Index.Typography
                                                  component="p"
                                                  sx={{ mb: 0.5 }}
                                                >
                                                  2. Name (નામ):
                                                </Index.Typography>
                                                <Index.TextField
                                                  fullWidth
                                                  size="small"
                                                  name="assistanceOrg2Name"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.assistanceOrg2Name || ""
                                                  }
                                                  disabled
                                                  // onChange={handleChange}
                                                  placeholder="Organization Name"
                                                />
                                              </Index.Box>
                                            </Index.Grid>

                                            <Index.Grid item xs={12} sm={6}>
                                              <Index.Box>
                                                <Index.Typography
                                                  component="p"
                                                  sx={{ mb: 0.5 }}
                                                >
                                                  Amount (રકમ):
                                                </Index.Typography>
                                                <Index.TextField
                                                  fullWidth
                                                  size="small"
                                                  type="number"
                                                  name="assistanceOrg2Amount"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.assistanceOrg2Amount ||
                                                    ""
                                                  }
                                                  // onChange={handleChange}
                                                  disabled
                                                  placeholder="Amount"
                                                  inputProps={{
                                                    min: 0,
                                                    step: 0.01,
                                                  }}
                                                />
                                              </Index.Box>
                                            </Index.Grid>
                                          </Index.Grid>
                                        </Index.Box>
                                      )}
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                          </>
                        )}

                        {/* After the existing Family Members Details table, add this new section: */}

                        {getViewData?.application[0]?.subSahayName?.toLowerCase() ===
                          "medical sahay" && (
                          <>
                            {/* Medical Sahay - Family Members Living Together */}
                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header" mt={5}>
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Details of the Applicant and Persons
                                      Residing with Them (અરજદાર અને તેમની સાથે
                                      રહેતા વ્યક્તિઓની વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table"
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>No.</Index.TableCell>
                                        <Index.TableCell>
                                          Full Name (પુરું નામ)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Relation (સંબંધ)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Age (ઉંમર)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Current Activity (વર્તમાન પ્રવૃત્તિ)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Monthly Income (માસિક આવક)
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.medicalSahay
                                        ?.familyMembersDetails?.length > 0 ? (
                                        getViewData.medicalSahay.familyMembersDetails.map(
                                          (member, index) => (
                                            <Index.TableRow key={index}>
                                              <Index.TableCell>
                                                {index + 1}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {member?.fullName || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {member?.relation || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {member?.age || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {member?.currentActivity || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {member?.monthlyIncome || "-"}
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          ),
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            scope="row"
                                            className="no-data-in-list"
                                            colSpan={6}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>

                            {/* Medical Details Section */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={12} md={12}>
                                    <Index.Box className="title-header">
                                      <Index.Box className="title-header-flex">
                                        <Index.Box className="title-main">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            Medical Details (તબીબી વિગતો)
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Total Family Members (કુલ કુટુંબના સભ્યો)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.totalFamilyMembers || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Earning Members (કમાતા સભ્યો)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.earningMembers || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Main Ailment Details (મુખ્ય બિમારીની વિગત)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.mainAilmentDetails || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Other Ailments (અન્ય બિમારીઓ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.otherAilmentsDetails || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Illness Duration (બિમારીનો સમયગાળો)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.illnessDuration || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Family Doctor Name (કૌટુંબિક ડોક્ટરનું
                                      નામ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.familyDoctorName || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Doctor Mobile (ડોક્ટર મોબાઇલ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.familyDoctorMobile || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Operation Details (ઓપરેશન વિગત)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.operationPerformed || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Doctor/Consultant Name (ડૉક્ટર/સલાહકારનું
                                      નામ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.doctorConsultantName || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Hospital/Nursing Home (હૉસ્પિટલ/નર્સિંગ
                                      હોમ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.hospitalNursingHomeName || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Grid>

                            {/* Expense Tables */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={12} md={12}>
                                    <Index.Box className="title-header">
                                      <Index.Box className="title-header-flex">
                                        <Index.Box className="title-main">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            Medication Expenses (દવાનો ખર્ચ)
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12}>
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table className="table-design-main barge-table">
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              Description
                                            </Index.TableCell>
                                            <Index.TableCell align="right">
                                              Amount
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.medicalSahay
                                            ?.medicationExpenses?.length > 0 ? (
                                            getViewData.medicalSahay.medicationExpenses.map(
                                              (expense, index) => (
                                                <Index.TableRow key={index}>
                                                  <Index.TableCell>
                                                    {expense?.description ||
                                                      "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell align="right">
                                                    ₹{expense?.amount || "0"}
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              ),
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                colSpan={2}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Grid>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={12} md={12}>
                                    <Index.Box className="title-header">
                                      <Index.Box className="title-header-flex">
                                        <Index.Box className="title-main">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            Hospital Expenses (હોસ્પિટલ ખર્ચ)
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12}>
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table className="table-design-main barge-table">
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              Description
                                            </Index.TableCell>
                                            <Index.TableCell align="right">
                                              Amount
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.medicalSahay
                                            ?.hospitalExpenses?.length > 0 ? (
                                            getViewData.medicalSahay.hospitalExpenses.map(
                                              (expense, index) => (
                                                <Index.TableRow key={index}>
                                                  <Index.TableCell>
                                                    {expense?.description ||
                                                      "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell align="right">
                                                    ₹{expense?.amount || "0"}
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              ),
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                colSpan={2}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Grid>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Grid>

                            {/* Hospital Stay Details */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={12} md={12}>
                                    <Index.Box className="title-header">
                                      <Index.Box className="title-header-flex">
                                        <Index.Box className="title-main">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            Hospital Stay Details (હોસ્પિટલમાં
                                            રોકાણ)
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Hospital Class (હોસ્પિટલ વર્ગ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.hospitalClass || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Hospital Days (દિવસો)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.hospitalDays || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Daily Charge (દૈનિક ચાર્જ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.dailyCharge || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      ICU Days (ICU દિવસો)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay?.icuDays ||
                                          ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      ICU Daily Charge (ICU દૈનિક ચાર્જ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.icuDailyCharge || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Treatment Reason (સારવારનું કારણ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.treatmentReason || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Grid>

                            {/* Mediclaim Policy Details */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={12} md={12}>
                                    <Index.Box className="title-header">
                                      <Index.Box className="title-header-flex">
                                        <Index.Box className="title-main">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            Mediclaim Policy Details (મેડિક્લેમ
                                            પોલિસી વિગત)
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Mediclaim Policy Taken (મેડિક્લેમ પોલિસી
                                      લીધી છે)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.mediclaimPolicyTaken === "yes"
                                            ? "Yes (હા)"
                                            : "No (ના)"
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  {getViewData?.medicalSahay
                                    ?.mediclaimPolicyTaken === "yes" && (
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={4}
                                    >
                                      <Index.Typography
                                        variant="label"
                                        component="label"
                                        className="input-label"
                                      >
                                        Policy Amount (પોલિસી રકમ)
                                      </Index.Typography>
                                      <Index.Box className="input-design-div with-border">
                                        <Index.TextField
                                          hiddenLabel
                                          variant="filled"
                                          className="admin-input-design input-placeholder"
                                          disabled
                                          value={
                                            getViewData?.medicalSahay
                                              ?.mediclaimPolicyAmount || ""
                                          }
                                        />
                                      </Index.Box>
                                    </Index.Grid>
                                  )}

                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Association Mediclaim Taken (સંસ્થા
                                      મેડિક્લેમ લીધી)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.associationMediclaimTaken ===
                                          "yes"
                                            ? "Yes (હા)"
                                            : "No (ના)"
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  {getViewData?.medicalSahay
                                    ?.mediclaimNotTakenReason && (
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={12}
                                      lg={12}
                                    >
                                      <Index.Typography
                                        variant="label"
                                        component="label"
                                        className="input-label"
                                      >
                                        Reason for Not Taking Mediclaim
                                        (મેડિક્લેમ ન લેવાનું કારણ)
                                      </Index.Typography>
                                      <Index.Box className="input-design-div with-border">
                                        <Index.TextField
                                          hiddenLabel
                                          variant="filled"
                                          className="admin-input-design input-placeholder"
                                          disabled
                                          multiline
                                          rows={2}
                                          value={
                                            getViewData?.medicalSahay
                                              ?.mediclaimNotTakenReason || ""
                                          }
                                        />
                                      </Index.Box>
                                    </Index.Grid>
                                  )}
                                </Index.Grid>
                              </Index.Box>
                            </Index.Grid>

                            {/* Known Person Details */}
                            {/* <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="main-card-box">
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={12} md={12}>
                                    <Index.Box className="title-header">
                                      <Index.Box className="title-header-flex">
                                        <Index.Box className="title-main">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            Known Person Details (જાણીતી
                                            વ્યક્તિની વિગત)
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Full Name (પુરું નામ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.knownPersonFullName || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Residence (નિવાસ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.knownPersonResidence || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Neighborhood (પડોશ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.knownPersonNeighborhood || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      Mobile (મોબાઇલ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        value={
                                          getViewData?.medicalSahay
                                            ?.knownPersonMobile || ""
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Grid> */}

                            {/* Detailed Bills - Medicine */}
                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header" mt={5}>
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Medicine Bills Details (દવાના બિલોની વિગત)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table"
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>
                                          Medical Store (મેડિકલ સ્ટોર)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Date (તારીખ)
                                        </Index.TableCell>
                                        <Index.TableCell align="right">
                                          Amount (રકમ)
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.medicalSahay
                                        ?.medicineBillsDetails?.length > 0 ? (
                                        getViewData.medicalSahay.medicineBillsDetails.map(
                                          (bill, index) => (
                                            <Index.TableRow key={index}>
                                              <Index.TableCell>
                                                {bill?.medicalStoreName || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {bill?.date || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="right">
                                                ₹{bill?.amount || "0"}
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          ),
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            colSpan={3}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>

                            {/* Diagnosis Bills */}
                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header" mt={5}>
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Diagnosis Bills (નિદાન બિલો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table"
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>
                                          Laboratory (પ્રયોગશાળા)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Date (તારીખ)
                                        </Index.TableCell>
                                        <Index.TableCell align="right">
                                          Amount (રકમ)
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.medicalSahay
                                        ?.diagnosisBillsDetails?.length > 0 ? (
                                        getViewData.medicalSahay.diagnosisBillsDetails.map(
                                          (bill, index) => (
                                            <Index.TableRow key={index}>
                                              <Index.TableCell>
                                                {bill?.laboratoryName || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {bill?.date || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="right">
                                                ₹{bill?.amount || "0"}
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          ),
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            colSpan={3}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>

                            {/* Hospital Bills */}
                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header" mt={5}>
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Hospital Bills (હોસ્પિટલ બિલો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table"
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>
                                          Details (વિગત)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Date (તારીખ)
                                        </Index.TableCell>
                                        <Index.TableCell align="right">
                                          Amount (રકમ)
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.medicalSahay
                                        ?.hospitalBillsDetails?.length > 0 ? (
                                        getViewData.medicalSahay.hospitalBillsDetails.map(
                                          (bill, index) => (
                                            <Index.TableRow key={index}>
                                              <Index.TableCell>
                                                {bill?.details || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {bill?.date || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="right">
                                                ₹{bill?.amount || "0"}
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          ),
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            colSpan={3}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>

                            {/* Other Expenses */}
                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header" mt={5}>
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Other Expenses (અન્ય ખર્ચા)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table"
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>
                                          Details (વિગત)
                                        </Index.TableCell>
                                        <Index.TableCell>
                                          Date (તારીખ)
                                        </Index.TableCell>
                                        <Index.TableCell align="right">
                                          Amount (રકમ)
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.medicalSahay
                                        ?.otherExpensesDetails?.length > 0 ? (
                                        getViewData.medicalSahay.otherExpensesDetails.map(
                                          (expense, index) => (
                                            <Index.TableRow key={index}>
                                              <Index.TableCell>
                                                {expense?.details || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {expense?.date || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="right">
                                                ₹{expense?.amount || "0"}
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          ),
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            colSpan={3}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>

                            {/* External Assistance */}
                            {getViewData?.medicalSahay
                              ?.receivedExternalAssistance === "yes" && (
                              <Index.Grid item xs={12} md={12}>
                                <Index.Box className="title-header" mt={5}>
                                  <Index.Box className="title-header-flex res-title-header-flex">
                                    <Index.Box className="title-main">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        External Assistance (બાહ્ય સહાય)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                                <Index.Box className="">
                                  <Index.TableContainer
                                    component={Index.Paper}
                                    className="table-container"
                                  >
                                    <Index.Table
                                      aria-label="simple table"
                                      className="table-design-main barge-table"
                                    >
                                      <Index.TableHead>
                                        <Index.TableRow>
                                          <Index.TableCell>
                                            Organization Name (સંસ્થાનું નામ)
                                          </Index.TableCell>
                                          <Index.TableCell align="right">
                                            Amount (રકમ)
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        {getViewData?.medicalSahay
                                          ?.externalAssistanceDetails?.length >
                                        0 ? (
                                          getViewData.medicalSahay.externalAssistanceDetails.map(
                                            (assistance, index) => (
                                              <Index.TableRow key={index}>
                                                <Index.TableCell>
                                                  {assistance?.organizationName ||
                                                    "-"}
                                                </Index.TableCell>
                                                <Index.TableCell align="right">
                                                  ₹{assistance?.amount || "0"}
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            ),
                                          )
                                        ) : (
                                          <Index.TableRow>
                                            <Index.TableCell
                                              colSpan={2}
                                              align="center"
                                            >
                                              No data available
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        )}
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>
                                </Index.Box>
                              </Index.Grid>
                            )}
                          </>
                        )}

                        <Index.Grid item xs={12} md={12}>
                          <Index.Box className="title-header" mt={5}>
                            <Index.Box className="title-header-flex res-title-header-flex">
                              <Index.Box className="title-main">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Current Year Sahay (વર્તમાન વર્ષ સહાય)
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="">
                            <Index.TableContainer
                              component={Index.Paper}
                              className="table-container"
                            >
                              <Index.Table
                                aria-label="simple table"
                                className="table-design-main barge-table "
                              >
                                <Index.TableHead>
                                  <Index.TableRow className="sahay-appli-tr">
                                    <Index.TableCell className="sahay-appli-tr">
                                      Family Id
                                    </Index.TableCell>
                                    <Index.TableCell className="user-sahay-td">
                                      User Name
                                    </Index.TableCell>
                                    <Index.TableCell className="sahay-appli-tr">
                                      Type Of Sahay
                                    </Index.TableCell>
                                    <Index.TableCell className="sahay-appli-tr">
                                      Sub Type Of Sahay
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Requested Sahay
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Approved Amount
                                    </Index.TableCell>

                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Year Of Sahay
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Staff Status
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Committee Status
                                    </Index.TableCell>
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody>
                                  {/* {getViewData?.relationRecords?.length ? (
                                    getViewData?.relationRecords */}
                                  {showCurrentYearSahayApplication?.length ? (
                                    showCurrentYearSahayApplication?.map(
                                      (data, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell>
                                              {/* {data?.name} */}
                                              {`${
                                                data?.familyId
                                                  ? data?.familyId
                                                  : data?.mem_family_id
                                              }` || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              {/* {data?.name} */}
                                              {`${data?.mem_fname} ${data?.mem_mname} ${data?.mem_lname}` ||
                                                "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.Sahay_category || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.SahayName || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.claimedAmmount
                                                ? data?.claimedAmmount
                                                : "0"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.approveAmount
                                                ? data?.approveAmount
                                                : "0"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {`${data?.fromSahayYear} - ${data?.toSahayYear}` ||
                                                "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.NewStatusColumn || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.committeeStatus || "-"}
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        );
                                      },
                                    )
                                  ) : (
                                    <Index.TableRow>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="no-data-in-list"
                                        colSpan={6}
                                        align="center"
                                      >
                                        No data available
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )}
                                </Index.TableBody>
                              </Index.Table>
                            </Index.TableContainer>
                          </Index.Box>
                        </Index.Grid>
                        {/* <Index.Grid item xs={12} md={12}>
                          <Index.Box className="title-header" mt={5}>
                            <Index.Box className="title-header-flex res-title-header-flex">
                              <Index.Box className="title-main">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Trust (ટ્રસ્ટ)
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="">
                            <Index.TableContainer
                              component={Index.Paper}
                              className="table-container"
                            >
                              <Index.Table
                                aria-label="simple table"
                                className="table-design-main barge-table "
                              >
                                <Index.TableHead>
                                  <Index.TableRow>
                                    <Index.TableCell align="left">
                                      Trust Name (ટ્રસ્ટનું નામ)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Account (એકાઉન્ટ)
                                    </Index.TableCell>
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody>
                                  {getViewData?.trustRecords?.length ? (
                                    getViewData?.trustRecords?.map(
                                      (data, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell align="left">
                                              {data?.trustName}
                                            </Index.TableCell>

                                            <Index.TableCell align="left">
                                              {data?.ammount}
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        );
                                      }
                                    )
                                  ) : (
                                    <Index.TableRow>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="no-data-in-list"
                                        colSpan={2}
                                        align="center"
                                      >
          
                                        No data available
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )}
                                </Index.TableBody>
                              </Index.Table>
                            </Index.TableContainer>
                          </Index.Box>
                        </Index.Grid> */}
                        {rollData.toLowerCase() === "committee" ? (
                          <Index.Grid item xs={12} md={12}>
                            <Index.Box className="title-header" mt={5}>
                              <Index.Box className="title-header-flex res-title-header-flex">
                                <Index.Box className="title-main">
                                  <Index.Typography
                                    variant="p"
                                    component="p"
                                    className="page-title"
                                  >
                                    Previous Year Sahay (ગત વર્ષ સહાય)
                                  </Index.Typography>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                            <Index.Box className="">
                              <Index.TableContainer
                                component={Index.Paper}
                                className="table-container"
                              >
                                <Index.Table
                                  aria-label="simple table"
                                  className="table-design-main barge-table "
                                >
                                  <Index.TableHead>
                                    <Index.TableRow>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Family Id (કૌટુંબિક આઈડી)
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        User Name (વપરાશકર્તા નામ)
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Type Of Sahay (સહાયનો પ્રકાર)
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Sub Type Of Sahay (સહાયનો પેટા પ્રકાર)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Requested Sahay (સહાયને વિનંતી કરી)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Approved Amount (મંજૂર રકમ)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Year Of Sahay (સહાયનું વર્ષ)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Start Date (પ્રારંભ તારીખ)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        No. Of Month (મહિનાની સંખ્યા)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Repay Details (ચુકવણી વિગતો)
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  </Index.TableHead>
                                  <Index.TableBody>
                                    {previousListData?.length ? (
                                      previousListData?.map((row, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.familyId}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {`${row?.firstName} ${row?.middleName} ${row?.lastName}`}
                                            </Index.TableCell>

                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.SahayName}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.Sahay_category}
                                            </Index.TableCell>

                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.sahayAmmount}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.approveAmount}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.toYear
                                                ? `${row?.fromYear}- ${row?.toYear}`
                                                : "---"}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.startDate
                                                ? new Date(
                                                    row?.startDate,
                                                  )?.toLocaleDateString("en-GB")
                                                : "-"}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.numberOfMonths !== null
                                                ? row?.numberOfMonths
                                                : "----"}
                                            </Index.TableCell>

                                            <LightTooltip
                                              title={row?.repayDetails}
                                            >
                                              <Index.TableCell
                                                align="left"
                                                className="sahay-appli-td"
                                              >
                                                {row.repayDetails !== null
                                                  ? row.repayDetails
                                                      // ?.split(" ")
                                                      ?.slice(0, 15) + "......"
                                                  : // ?.join(" ")+ "..."
                                                    "----"}
                                              </Index.TableCell>
                                            </LightTooltip>
                                          </Index.TableRow>
                                        );
                                      })
                                    ) : (
                                      <Index.TableRow>
                                        <Index.TableCell
                                          component="td"
                                          variant="td"
                                          scope="row"
                                          className="no-data-in-list"
                                          colSpan={6}
                                          align="center"
                                        >
                                          No data available
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    )}
                                  </Index.TableBody>
                                </Index.Table>
                              </Index.TableContainer>
                            </Index.Box>
                          </Index.Grid>
                        ) : (
                          ""
                        )}
                        {/* table */}

                        {/* Current Program Data */}
                        <Index.Grid item xs={12} md={12}>
                          <Index.Box className="title-header" mt={5}>
                            <Index.Box className="title-header-flex res-title-header-flex">
                              <Index.Box className="title-main">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Current Year Sahay Program(વર્તમાન વર્ષ સહાય
                                  કાર્યક્રમ)
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="">
                            <Index.TableContainer
                              component={Index.Paper}
                              className="table-container"
                            >
                              <Index.Table
                                aria-label="simple table"
                                className="table-design-main barge-table "
                              >
                                <Index.TableHead>
                                  <Index.TableRow className="sahay-appli-tr">
                                    <Index.TableCell className="sahay-appli-tr">
                                      Family Id
                                    </Index.TableCell>
                                    <Index.TableCell className="user-sahay-td">
                                      User Name
                                    </Index.TableCell>
                                    <Index.TableCell className="sahay-appli-tr">
                                      Type Of Sahay
                                    </Index.TableCell>
                                    <Index.TableCell className="sahay-appli-tr">
                                      Program Name
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Year Of Program Bill
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Total Amount
                                    </Index.TableCell>
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody>
                                  {currentAndPreviousProgramData?.length ? (
                                    currentAndPreviousProgramData
                                      ?.filter(
                                        (c) => c.yearType == "currentYear",
                                      )
                                      ?.map((data, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell>
                                              {data?.familyId || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              {data.memberName || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.sahayType || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.programName || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.createdAt || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.totalAmount || "-"}
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        );
                                      })
                                  ) : (
                                    <Index.TableRow>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="no-data-in-list"
                                        colSpan={6}
                                        align="center"
                                      >
                                        No data available
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )}
                                </Index.TableBody>
                              </Index.Table>
                            </Index.TableContainer>
                          </Index.Box>
                        </Index.Grid>

                        {/* Pervious Year program Data */}
                        {rollData.toLowerCase() === "committee" ? (
                          <Index.Grid item xs={12} md={12}>
                            <Index.Box className="title-header" mt={5}>
                              <Index.Box className="title-header-flex res-title-header-flex">
                                <Index.Box className="title-main">
                                  <Index.Typography
                                    variant="p"
                                    component="p"
                                    className="page-title"
                                  >
                                    Previous Year Sahay Program (ગત વર્ષ સહાય
                                    કાર્યક્રમ)
                                  </Index.Typography>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                            <Index.Box className="">
                              <Index.TableContainer
                                component={Index.Paper}
                                className="table-container"
                              >
                                <Index.Table
                                  aria-label="simple table"
                                  className="table-design-main barge-table "
                                >
                                  <Index.TableHead>
                                    <Index.TableRow className="sahay-appli-tr">
                                      <Index.TableCell className="sahay-appli-tr">
                                        Family Id
                                      </Index.TableCell>
                                      <Index.TableCell className="user-sahay-td">
                                        User Name
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Type Of Sahay
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Program Name
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Year Of Program Bill
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Total Amount
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  </Index.TableHead>
                                  <Index.TableBody>
                                    {currentAndPreviousProgramData?.length ? (
                                      currentAndPreviousProgramData
                                        ?.filter(
                                          (c) => c.yearType == "previousYear",
                                        )
                                        ?.map((data, index) => {
                                          return (
                                            <Index.TableRow key={index}>
                                              <Index.TableCell>
                                                {data?.familyId || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell>
                                                {data.memberName || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="left">
                                                {data?.sahayType || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="left">
                                                {data?.programName || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="left">
                                                {data?.createdAt || "-"}
                                              </Index.TableCell>
                                              <Index.TableCell align="left">
                                                {data?.totalAmount || "-"}
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          );
                                        })
                                    ) : (
                                      <Index.TableRow>
                                        <Index.TableCell
                                          component="td"
                                          variant="td"
                                          scope="row"
                                          className="no-data-in-list"
                                          colSpan={6}
                                          align="center"
                                        >
                                          No data available
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    )}
                                  </Index.TableBody>
                                </Index.Table>
                              </Index.TableContainer>
                            </Index.Box>
                          </Index.Grid>
                        ) : (
                          ""
                        )}
                      </Index.Grid>

                      <Index.Box className="line" mt={3} mb={3}></Index.Box>
                    </Index.Box>
                  </form>
                )}
              </PagesIndex.Formik>
            </Index.Box>
          </Index.Box>

          <Index.Modal
            open={uploadOpen}
            onClose={handleCloseUploadModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="modal-delete modal"
          >
            <Index.Box
              sx={style}
              className="delete-modal-inner-main modal-inner approve-amount-model"
            >
              <PagesIndex.Formik
                enableReinitialize
                onSubmit={handleUploadSubmit}
                // validationSchema={uploadLoanDocSchema}
                initialValues={{
                  loanDoc: [],
                }}
              >
                {({
                  values,
                  handleChange,
                  handleSubmit,
                  touched,
                  setFieldValue,
                  handleBlur,
                  errors,
                  isValid,
                  isSubmitting,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Index.Box
                    // className={`${
                    //   subSahayType == "" ? "remark-textarea-details" : ""
                    // }`}
                    >
                      <Index.Box className="set-text-area ">
                        <Index.Box
                          sx={{ flexGrow: 1 }}
                          className="al-form-groups"
                        >
                          <Index.Grid container spacing={2}>
                            <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                              <Index.Box
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <Index.IconButton
                                  onClick={handleCloseUploadModal}
                                >
                                  <Index.CloseIcon />
                                </Index.IconButton>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                              <Index.Box className="lable-input-grp">
                                <Index.Typography
                                  component="p"
                                  className="in-label"
                                >
                                  Upload Document
                                </Index.Typography>
                                <Index.Box className="select-position">
                                  <input
                                    type="file"
                                    name="loanDoc"
                                    className="ori-input"
                                    onChange={(event) => {
                                      const files = Array.from(
                                        event.target.files,
                                      );
                                      setFieldValue("loanDoc", files);
                                    }}
                                    multiple
                                  />

                                  <Index.Box className="select-file">
                                    Upload Your Document
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              {errors?.loanDoc && touched?.loanDoc && (
                                <p
                                  className="error-text"
                                  style={{ marginTop: "10px" }}
                                >
                                  {errors?.loanDoc}
                                </p>
                              )}
                            </Index.Grid>

                            <Index.Grid item xs={8}>
                              <Index.Box className="select-view-document-name remove-margin-upload">
                                {values.loanDoc?.length > 0 &&
                                  values?.loanDoc?.map((item, fileIndex) => {
                                    return (
                                      <Index.Box className="select-view-document-name mt-select-doc">
                                        <Index.Box className="document-name">
                                          <Index.Typography
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              window.open(
                                                item instanceof Blob
                                                  ? URL.createObjectURL(item)
                                                  : // : `${imagePath}${values.documents[index].filePath}`
                                                    `${imagePath}${item?.filename}`,
                                              );
                                            }}
                                          >
                                            {item instanceof Blob
                                              ? item.name
                                              : item?.document}
                                          </Index.Typography>
                                          <Index.IconButton
                                            onClick={() => {
                                              const updatedFiles =
                                                values.loanDoc?.filter(
                                                  (ele, i) => i !== fileIndex,
                                                );
                                              setFieldValue(
                                                `loanDoc`,
                                                updatedFiles,
                                              );
                                            }}
                                          >
                                            <Index.ClearIcon className="muiico-cancel" />
                                          </Index.IconButton>
                                        </Index.Box>
                                      </Index.Box>
                                    );
                                  })}
                              </Index.Box>
                            </Index.Grid>
                          </Index.Grid>
                        </Index.Box>
                      </Index.Box>
                      <Index.Box className="btn-submit-area">
                        <Index.Box className="common-button blue-button change-password-btn update_priofile_btn">
                          <Index.Button
                            variant="contained"
                            disableRipple
                            type="submit"
                          >
                            Submit
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </form>
                )}
              </PagesIndex.Formik>
            </Index.Box>
          </Index.Modal>
        </>
      )}
    </>
  );
};

export default SahayApplicationView;
